module.exports = __webpack_public_path__ + "/static/assets/3dcd3ad2540cfd717d5e5ba2584c22da.jpg";